<script>
    import { mapState } from "vuex";
    import ImageResponsive from "@/components/ImageResponsive";
    import ThePersonalButton from "@/ThePersonal/components/ui/ThePersonalButton";

    export default {
        name: "ThePersonalSupportSide",
        components: { ImageResponsive, ThePersonalButton },
        computed: {
            ...mapState("Root", {
                phone: (state) => state.site.phone,
            }),
            imageUrl() {
                return {
                    desktop: `/static/${this.$root.$_name}/profile/support-aside.png`,
                    mobile: `/static/${this.$root.$_name}/profile/support-aside--mobile.png`,
                };
            },
        },
        methods: {
            callUsedeskChat() {
                if (window.usedeskMessenger) {
                    window.usedeskMessenger.open("chat");
                }
            },
        },
    };
</script>

<template>
    <div class="the-personal-support-side">
        <div class="the-personal-support-side__image">
            <image-responsive
                :mobile="imageUrl.mobile"
                :desktop="imageUrl.desktop"
            ></image-responsive>
        </div>
        <div class="the-personal-support-side__text">
            Если вы не нашли ответа на свой вопрос — обратитесь в службу поддержки по номеру
        </div>
        <a :href="`tel:${phone}`" class="the-personal-support-side__phone">
            {{ phone }}
        </a>
        <the-personal-button @click="callUsedeskChat">Написать в чат</the-personal-button>
    </div>
</template>

<style lang="scss">
    .the-personal-support-side {
        position: relative;
        z-index: 3;
        padding: 15px;
        background-color: #fff;
        border-radius: $personal-box-radius;
        box-shadow: $personal-common-shadow-min;
        border: $personal-common-border-full;
        @include bp($bp-desktop-sm) {
            @include sticky(calc(var(--header-height) + 30px));
            padding: 110px 20px 20px;
            box-shadow: $personal-common-shadow-max;
        }
    }

    .the-personal-support-side__image {
        position: absolute;
        right: 0;
        top: 0;
        width: 134px;
        height: 103px;
        img {
            width: 100%;
        }
        @include bp($bp-desktop-sm) {
            width: 100%;
            height: 100px;
        }
    }

    .the-personal-support-side__text {
        max-width: 180px;
        margin-bottom: 12px;
        color: #8f90a6;
        font-size: 12px;
        line-height: 16px;
        @include bp($bp-desktop-sm) {
            max-width: 100%;
            margin-bottom: 10px;
            color: #555770;
            font-size: 14px;
            font-weight: 300;
            line-height: 22px;
        }
    }

    .the-personal-support-side__phone {
        display: block;
        margin-bottom: 20px;
        color: $personal-widget-link-color;
        font-size: 16px;
        line-height: 20px;
        &:hover {
            text-decoration: underline;
        }
    }
</style>
